import React, { useState } from "react";
import { toast } from "sonner";
import { Loader2, Mail } from "lucide-react";
import { submitForm } from "@/lib/api";
import { cn } from "@/lib/utils";

export default function NewsletterForm({ dark = false, compact = false }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handle = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await submitForm({ form_type: "newsletter", email });
      toast.success("You're in. Watch your inbox.");
      setEmail("");
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handle} data-testid="newsletter-form" className={cn("flex w-full gap-2", compact ? "flex-row" : "flex-col sm:flex-row")}>
      <div className="relative flex-1">
        <Mail className={cn("pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2", dark ? "text-slate-400" : "text-navy/40")} />
        <input
          data-testid="newsletter-email"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Work email"
          className={cn(
            "w-full rounded-full border py-3 pl-11 pr-4 text-sm outline-none transition-colors focus:border-emerald2",
            dark ? "border-white/15 bg-white/5 text-white placeholder:text-slate-400" : "border-border bg-white text-navy placeholder:text-navy/40"
          )}
        />
      </div>
      <button
        data-testid="newsletter-submit"
        type="submit"
        disabled={loading}
        className="inline-flex items-center justify-center gap-2 rounded-full bg-ethanolOrange px-6 py-3 text-sm font-bold text-navy transition-all hover:-translate-y-0.5 hover:bg-orangeDeep disabled:opacity-60"
      >
        {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
        Keep me posted
      </button>
    </form>
  );
}
